const fontLoads = new Map();

export function normalizeEmbedFont(font) {
  if (!font || typeof font !== "object" || Array.isArray(font)) return null;
  const id = typeof font.id === "string" ? font.id.trim() : "";
  const family = typeof font.family === "string" ? font.family.trim() : "";
  const file = typeof font.file === "string" ? font.file.trim() : "";
  const weight = typeof font.weight === "string" ? font.weight.trim() : "100 900";
  if (!id || !family || !/^[a-z0-9-]+-latin-wght-normal\.woff2$/.test(file)) return null;
  return { id, family, file, weight: weight || "100 900" };
}

export function getEmbedFontCssVariables(font) {
  const normalized = normalizeEmbedFont(font);
  return normalized
    ? { "--map-font-family": `"${normalized.family}", var(--font-ui, Manrope), sans-serif` }
    : {};
}

export async function ensureEmbedFontLoaded(font, fontBaseUrl) {
  const normalized = normalizeEmbedFont(font);
  if (!normalized || typeof FontFace === "undefined") return normalized;
  const base = String(fontBaseUrl || "").replace(/\/+$/, "");
  const key = `${base}/${normalized.file}`;
  if (!fontLoads.has(key)) {
    fontLoads.set(key, (async () => {
      const face = new FontFace(
        normalized.family,
        `url("${key}") format("woff2")`,
        { style: "normal", weight: normalized.weight, display: "swap" }
      );
      const loaded = await face.load();
      document.fonts.add(loaded);
      return normalized;
    })().catch((error) => {
      fontLoads.delete(key);
      throw error;
    }));
  }
  return fontLoads.get(key);
}
